/**
 * @file index.tsx
 *
 * @fileoverview Social media links for the application based on backend configuration.
 */
import React from 'react';
import SocialMediaLinks from '~/jobiqo/components/SocialMedia/Links';
import { useConfig } from '~/jobiqo/context/config';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

export default function FooterSocialMediaLinks() {
  const { getConfigByName } = useConfig();
  const { APP } = useFrontendConfig();

  const config = getConfigByName('social_links');
  if (!config?.value) {
    return null;
  }

  const socialLinks: Record<string, string> = {};
  for (const item of config.value) {
    if (typeof item === 'object' && 'key' in item && 'value' in item) {
      socialLinks[item.key as string] = item.value as string;
    }
  }

  return (
    <SocialMediaLinks
      hrefs={socialLinks}
      coloredIcons={APP.SOCIAL_ICONS_COLORED}
    />
  );
}
export { FooterSocialMediaLinks };
